;import $ from 'jquery';
window.$ = window.jQuery = $;
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgHash from 'lightgallery/plugins/hash';
import 'jquery.scrollto';
import './vendor/ba-debug.min.js';

(function($){
//------------------------------------------------------------------------------------------------------------------------
    // Page constructor

    // Page constructor
    window.Page = {

//------------------------------------------------------------------------------------------------------------------------
    // Global variables

        // Responsive breakpoints
        mobileMaxWidth: 767.98,
        tabletMaxWidth: 991.98,

        // lightGallery
        lightGallery: {
            download: false,
            enableDrag: false,
            plugins: [lgVideo, lgHash],
            customSlideName: true,
            autoplayFirstVideo: false,
            gotoNextSlideOnVideoEnd: false,
            subHtmlSelectorRelative: true,
            youTubePlayerParams: {
                color: '#3b6ed2',
                modestbranding: 1
            }
        },

        // scrollTo
        scrollTo: {
            axis: 'y',
            duration: 300,
            offset: true,
            showTabHash: true
        },

        // Modal
        modal: {
            messages: false,
            title: false
        },

        // Animation
        animation: 300,

//------------------------------------------------------------------------------------------------------------------------
    // Application

        // Set layout
        setLayout: function(){
            // Load navbar
            window.Page.loadNavbar();

            // Load galleries
            window.Page.loadGalleries();

            // Load scrollTo
            window.Page.loadScrollTo();

            // Load modals
            window.Page.loadModals();
        },

        // Layout loaded
        layoutLoaded: function(){
        },

        // Resize layout
        resizeLayout: function(){
            // Shrink navbar
            window.Page.navbarShrink();
        },

//------------------------------------------------------------------------------------------------------------------------
    // Navbar

        // Load navbar
        loadNavbar: function(){
            // Shrink navbar
            window.Page.navbarShrink();
        },

        // Shrink navbar
        navbarShrink: function(){
            var $navbar = $('#nav-main');
            if(!$navbar.length){
                return false;
            }
            if(window.scrollY === 0){
                $navbar.removeClass('navbar-shrink');
            } else {
                $navbar.addClass('navbar-shrink');
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // lightGallery

        // Load galleries
        loadGalleries: function(){
            // Load all galleries
            $('.gallery').each(function(i, target){
                window.Page.loadGallery($(target), { selector: '.item' });
            });

            // Load post video galleries
            $('.single-gallery').each(function(i, target){
                window.Page.loadGallery($(target), { selector: 'this', counter: false });
            });
        },

        // Load gallery
        loadGallery: function($target, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.lightGallery, params);

            // Gallery settings
            if(settings.dynamic){
                settings.dynamicEl = $target.data('gallery');
            }
            if($target.data('gallery-id')){
                settings.galleryId = $target.data('gallery-id');
            }

            // Load gallery
            var lg = lightGallery($target.get(0), settings);
            $target.data('lightgallery', lg);
        },

//------------------------------------------------------------------------------------------------------------------------
    // scrollTo

        // Load scrollTo
        loadScrollTo: function(){
            // CTA
            $(document).on('click', 'a[href^="#"], a[href^="' + window.location.pathname + '#"], a[href^="' + window.location.origin + window.location.pathname + '#"]', function(e){
                e.preventDefault();
                window.Page.scrollToHash(this.hash);
            });

            // Wait for all images before scroll to hash
            if(window.location.hash){
                window.Page.loadImages($('img:visible'), 0, (images) => {
                    window.Page.scrollToHash(window.location.hash);
                });
            }
        },

        // Load images
        loadImages: function(images, index, callback){
            if(index < images.length){
                let img = new Image();
                img.src = $(images[index]).attr('src');
                images[index].obj = img;
                images[index].obj.onload = function(){
                    window.Page.loadImages(images, ++index, callback);
                };
                images[index].obj.onerror = function(){
                    window.Page.showError('Váratlan hiba történt. (#JLI001)');
                    window.Page.loadImages(images, ++index, callback);
                };
            }
            else {
                callback(images);
            }
        },

        // Scroll to content
        scrollToHash: function(hash, params){
            if(!/^\#[0-9a-z_-]+$/gi.test(hash) || (!$(hash).is(':visible') && !$(hash).is('.tab-pane'))){
                return false;
            }

            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.scrollTo, params);

            // Target
            var $target = $(window).height() < $('body').height() ? $(window) : $('body');
            var $tab = $('[data-bs-target="' + hash + '"]');
            var $navbar = $('.navbar-collapse', 'header');
            var $sidebar = $('.sidebar-collapse', '.sidebar-nav');

            // Offset by fixed navbar's height
            if(settings.offset){
                var offset = $(hash).is('.tab-pane') ? -2 * $('.navbar').outerHeight() : -$('.navbar').outerHeight();
                settings.offset = { left: 0, top: 0 };
                //settings.offset.top = ($(window).width() > window.Page.tabletMaxWidth ? offset : 0);
                settings.offset.top = offset;
            }

            // Scroll to content after tab is open
            if($(hash).is('.tab-pane') && !$(hash).hasClass('show')){
                $tab.one('shown.bs.tab', function(e){
                    $target.scrollTo(hash, settings);
                });
            }
            // Scroll to content after navbar is closed
            else if($navbar.hasClass('show')){
                $navbar.one('hidden.bs.collapse', function(e){
                    $target.scrollTo(hash, settings);
                });
            }
            // Scroll to content immediately
            else {
                $target.scrollTo(hash, settings);
            }

            // Open tab if there's one
            if($(hash).is('.tab-pane') && !$(hash).hasClass('show')){
                bootstrap.Tab.getInstance($tab.get(0)).show();
            }

            // Close navbar on mobile view if open
            if($navbar.hasClass('show')){
                var bsCollapseNav = new bootstrap.Collapse($navbar.get(0), { toggle: false });
                bsCollapseNav.hide();
            }

            // Close sidebar on mobile view if open
            if($sidebar.hasClass('show')){
                var bsCollapseSide = new bootstrap.Collapse($sidebar.get(0), { toggle: false });
                bsCollapseSide.hide();
            }

            // Show hash
            if(hash != '#top' && (!$(hash).is('.tab-pane') || settings.showTabHash)){
                history.pushState({}, '', hash);
            }
        },

//------------------------------------------------------------------------------------------------------------------------
    // Modals

        // Load modals
        loadModals: function(){
            // Load modals
            $('.modal').each(function(i, target){
                var modal = new bootstrap.Modal($(target).get(0));

                // Show default modals
                if($(target).attr('data-bs-show') == 'true'){
                    modal.show();
                }

                // Modal has been open
                $(target).on('shown.bs.modal', function(e){
                    // Bootstrap bugfix: losing autofocus in modals
                    $(':input[autofocus]:first', $(this)).focus();
                });
            });
        },

        // Show modal
        showModal: function(id, params){
            // Override settings
            params = typeof params !== 'undefined' ? params : {};
            var settings = $.extend(true, {}, window.Page.modal, params);
            if(!id) return false;

            // Check if modal exists
            var $modal = $('#modal-' + id);
            if(!$modal.length){
                return false;
            }
            var modal = bootstrap.Modal.getOrCreateInstance($modal.get(0));

            // Substitute parameters
            if(params !== false){
                $('.modal-title', $modal).html(settings.title ? settings.title : '');
                $('.modal-body', $modal).empty();
                if(typeof settings.errors !== 'undefined'){
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.errors);
                }
                else {
                    window.Page.appendTextAsPs($('.modal-body', $modal), settings.messages);
                }
            }

            // Show modal
            modal.show();
        },

        // Show error messages
        showError: function(messages, errors){
            window.Page.showModal('error', { title: 'Hiba történt!', messages: messages, errors: errors });
        },

        // Append text array as paragraphs
        appendTextAsPs: function($target, text){
            if(!$target.length){
                return false;
            }

            // Convert variable to array
            text = typeof text !== 'undefined' ? text : [];
            if(text.constructor === String){
                text = [text];
            }
            else if(text.constructor === Array){
                text = text;
            }
            else if(typeof text === 'object'){
                var arr = [];
                $.each(text, function(i, value){
                    arr.push(value);
                });
                text = arr;
            }
            else {
                text = [];
            }

            // Append text
            $.each(text, function(i, line){
                $target.append($('<p />').html(line));
            });
        },

//------------------------------------------------------------------------------------------------------------------------

    };

//------------------------------------------------------------------------------------------------------------------------
    // Document ready

    // Document ready
    $(function(){
        // Set layout
        window.Page.setLayout();

        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window loaded

    // Window loaded
    $(window).on('load', function(e){
        // Resize layout
        window.Page.resizeLayout();

        // Layout loaded
        window.Page.layoutLoaded();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window resized or orientation changed

    // Window resized or orientation changed
    $(window).on('orientationchange resize', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
    // Window scrolled

    // Window scrolled
    $(window).on('scroll', function(e){
        // Resize layout
        window.Page.resizeLayout();
    });

//------------------------------------------------------------------------------------------------------------------------
})(jQuery);
